import React, { useEffect, useState } from 'react';
import { fetchProfileImage } from '../services/api';

export default function StudentProfileAvatar({ student, className }: any) {
  const filename = student.avatar_filename || student.avatar_url || '';
  const [image, setImage] = useState<any>(null);
  const [failedFilename, setFailedFilename] = useState<any>(null);
  const initials = `${String(student.first_name || '').trim()[0] || String(student.student_id || '?')[0]}${String(student.last_name || '').trim()[0] || ''}`.toUpperCase();
  const name = `${student.first_name || ''} ${student.last_name || ''}`.trim() || `Student ${student.student_id}`;

  useEffect(() => {
    if (!filename) return undefined;
    let cancelled = false;
    let objectUrl;
    fetchProfileImage(filename)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setImage({ filename, url: objectUrl });
        setFailedFilename(null);
      })
      .catch(() => {
        if (!cancelled) setFailedFilename(filename);
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [filename]);

  const failed = filename && failedFilename === filename;
  const imageUrl = image?.filename === filename && !failed ? image.url : '';
  return (
    <span className={className} title={failed ? `Profile picture unavailable for ${name}.` : undefined}>
      {imageUrl ? (
        <img src={imageUrl} alt={`${name} avatar`} onError={() => setFailedFilename(filename)} />
      ) : (
        <span aria-hidden="true">{initials}</span>
      )}
      {failed && <span className="family-home-avatar-error" role="status">Profile picture unavailable for {name}.</span>}
    </span>
  );
}
